import React from 'react';
import classNames from 'classnames';

import './ProgressLine.scss';

export interface ProgressLineProps {
  percentage: number;
  value: number;
  caption: string;
  isRed?: boolean;
}

export const ProgressLine = ({ percentage, value = 0, caption, isRed }: ProgressLineProps) => (
  <div styleName="progress-line">
    <div styleName="progress-line__caption">
      {caption}
    </div>
    <div styleName={classNames('progress-line__overlap',
      {'progress-line__overlap--red': isRed})}>
      <div styleName="progress-line__rectangle" style={{ width: `${Math.round(percentage)}%`}} />
    </div>
    <div styleName="progress-line__value">{Math.round(value)}</div>
  </div>
);
